import React, { useEffect } from "react";
import "./BookAppointment.css";
import ProgressBarsWithArrows from "../ProgressBarsWithArrows/ProgressBarsWithArrows";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { rescheduleAppointment,bookAppointment } from "../../services/api";
// Import the icons
import calendarIcon from "../../assets/images/calendar_icon.png";
import clockIcon from "../../assets/images/clock.png";
import locationIcon from "../../assets/images/globe.png";
interface RequestBody {
  user_id: string;
  datetime: string;
  pm_status?: string; 
}
const BookAppointment: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { date, time, timeZone, appointmentId, isReschedule } = location.state || {};

  useEffect(() => {
  }, [date, time, appointmentId, isReschedule]);

  const handleBack = () => {
    navigate("/dashboard/schedule_consultation");
  };

  const formatDate = (date: Date, time: string) => {
    const [timePart, ampm] = time.split(" ");
    const [hours, minutes] = timePart.split(":");
    date.setHours(ampm === "PM" ? +hours + 12 : +hours);
    date.setMinutes(+minutes);

    return new Intl.DateTimeFormat("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }).format(date);
  };

  const formattedDate = date ? formatDate(new Date(date), time) : "N/A";

  const appointmentDetails = {
    duration: "15 mins",
    date: formattedDate,
    location: timeZone,
  };

  const handleChangeDateTime = () => {
    navigate("/dashboard/schedule_consultation");
  };

  // const handleNext = ()=>{
  //   navigate("/dashboard/appointment_booked");

  // }
  const handleNext = async () => {
    try {
      if (isReschedule) {
        const rescheduledAppointment = await rescheduleAppointment(appointmentId, "1977900", date, time);
      } else {
        const bookedAppointment = await bookAppointment("1977900", date, time);
        console.log("Appointment booked", bookedAppointment);
      }
      navigate("/dashboard/appointment_booked");
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while booking or rescheduling the appointment.");
    }
  };
  return (
    <div className="schedule-container">
      <h1 className="schedule-heading">Schedule Your Consult</h1>

      <ProgressBarsWithArrows onBack={handleBack} onNext={handleNext} />
      <p className="select-date-time-text">
        Choose A date for your appointment
      </p>

      <div className="appointment-details">
        <h3 className="appointment-title">Booking Details</h3>
        <div className="appointment-info">
          <p>
            <img
              src={calendarIcon}
              alt="Calendar Icon"
              className="appointment-icon"
            />
            <strong>Duration:</strong> {appointmentDetails.duration}
          </p>
          <p>
            <img
              src={clockIcon}
              alt="Clock Icon"
              className="appointment-icon"
            />
            <strong>Date:</strong> {appointmentDetails.date}
          </p>
          <p>
            <img
              src={locationIcon}
              alt="Location Icon"
              className="appointment-icon"
            />
            <strong>Location:</strong> {appointmentDetails.location}
          </p>
          <a
            href="#change-date-time"
            className="change-link"
            onClick={handleChangeDateTime}
          >
            Change Date/Time
          </a>
        </div>
      </div>

      <button className="next-button" onClick={handleNext}>
        Next →
      </button>
    </div>
  );
};

export default BookAppointment;
